function requiredUrl(value: string | undefined, fallback: string, name: string): string {
  if (value?.trim()) return value.trim().replace(/\/+$/, '');
  if (import.meta.env.DEV || import.meta.env.MODE === 'test') return fallback;
  throw new Error(`${name} is required for release builds.`);
}
const withoutTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const optionalUrl = (value: string | undefined): string | null => {
  const candidate = value?.trim();
  if (!candidate) return null;

  try {
    const parsed = new URL(candidate);
    return parsed.protocol === 'https:' || parsed.hostname === 'localhost'
      ? withoutTrailingSlash(candidate)
      : null;
  } catch {
    return null;
  }
};

export const env = {
  apiBaseUrl: requiredUrl(
    import.meta.env.VITE_API_BASE_URL,
    'http://localhost:3100/api/v1',
    'VITE_API_BASE_URL',
  ),
  publicSiteUrl: requiredUrl(
    import.meta.env.VITE_PUBLIC_SITE_URL,
    'http://localhost:3103',
    'VITE_PUBLIC_SITE_URL',
  ),
  nativeAppLinkBase: optionalUrl(import.meta.env.VITE_NATIVE_APP_LINK_BASE),
  iosAppStoreUrl: optionalUrl(import.meta.env.VITE_IOS_APP_STORE_URL),
  androidAppStoreUrl: optionalUrl(import.meta.env.VITE_ANDROID_APP_STORE_URL),
  /** The admin web app's origin, which publishes the terms and the imprint. */
  legalSiteUrl:
    optionalUrl(import.meta.env.VITE_LEGAL_SITE_URL) ??
    (import.meta.env.DEV ? 'http://localhost:3101' : null),
  mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN?.trim() || null,
  mixpanelApiHost:
    optionalUrl(import.meta.env.VITE_MIXPANEL_API_HOST) ?? 'https://api-eu.mixpanel.com',
} as const;
